import { Component, Vue, Prop } from 'vue-property-decorator';
import { itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';
import CustomFileSystemProvider from 'devextreme/file_management/custom_provider';
import { DxFileManager, DxPermissions, DxItemView, DxToolbar, DxItem, DxUpload } from 'devextreme-vue/file-manager';
import { DxPopup } from 'devextreme-vue/popup';
import FileSystemItem from 'devextreme/file_management/file_system_item';
import { locale, loadMessages } from "devextreme/localization";
import es from "../../../public/assets/lang/es.json";
import va from "../../../public/assets/lang/va.json";
import fileModule from '@/store/modules/file.module';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';

@Component({
    components: {
        DxFileManager,
        DxPermissions,
        DxPopup,
        DxItemView,
        DxToolbar,
        DxItem,
        DxUpload,
    },
})
export default class FileManager extends Vue {
    @Prop() public collaborativeAreaId!: String;
    public bytes: Uint8Array = new Uint8Array();
    public chunksSum: number = 0;
    public isCollaborativeArea = false;
    public ambitId: String = '-1';
    public currentPath:String = fileModule.filePath.path;

    public remoteProvider = new CustomFileSystemProvider({
        keyExpr: "id",
        getItems: async (dir: FileSystemItem) => {
            var parentId = 0;
            if(dir.path != '') parentId = dir.dataItem.id;
            if(this.collaborativeAreaId != undefined ) this.ambitId = this.collaborativeAreaId;
            else {
                if(dir.path != '' && dir.dataItem.parentId == -1) {
                    this.ambitId  = dir.dataItem.ambitId;
                    parentId = 0;
                }
            }
            return itiHttpService.get(API.fileManager + '?parentId=' + parentId 
                                        + '&collaborativeAreaId=' 
                                        + this.ambitId).catch();

        },
        createDirectory: (dir, nombre) => {
            var parentId = 0;
            if(dir.path != '') parentId = dir.dataItem.id;
            return itiHttpService.post(API.fileManager + '/PostDirectory' + '?userId=1' 
                                            + '&name=' + nombre + '&parentId=' 
                                            + parentId + '&collaborativeAreaId=' 
                                            + this.ambitId,'').catch();
        },
        renameItem: (item: FileSystemItem, nombre) => {
            return itiHttpService.put(API.fileManager + '/ChangeName?id=' +  item.dataItem.id + '&newName=' 
                                                      + nombre,'').catch();
        },
        moveItem: (dirSrc, dir) => {
            var dstParentId = 0;
            if(dir.path != '') dstParentId = dir.dataItem.id;
            return itiHttpService.put(API.fileManager + '/MoveFile?id=' +  dirSrc.dataItem.id 
                                                      + '&dstParentId=' + dstParentId
                                                      ,'').catch();
        },
        deleteItem: (item) => {
            //console.log(item.dataItem.id);
            return itiHttpService.delete(API.fileManager + '?id=' + item.dataItem.id,'').catch();
        },
        copyItem: (file, dstDir) => {
            var parentId = 0;
            if(dstDir.path != '') parentId = dstDir.dataItem.id;
            return itiHttpService.put(API.fileManager + '/CopyFile?id=' +  file.dataItem.id 
                                                      + '&dstParentId=' + parentId
                                                      ,'').catch();
        },
        downloadItems: (item) => {
            itiHttpService.get(API.fileManager + '/DownloadFile?id=' + item[0].dataItem.id).then((response) => {
                const uintArray: Uint8Array = new Uint8Array(Buffer.from(response, 'base64'));
                var blob = new Blob([uintArray]);
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = item[0].name;
                link.click();
            })
        
        },
        uploadFileChunk: (fileData, chunksInfo, dir) => {
            var parentId = 0;
            if(dir.path != '') parentId = dir.dataItem.id;
            chunksInfo.chunkBlob.arrayBuffer().then(buffer => {
                let unit8Array = new Uint8Array(buffer);
                var mergedArray = new Uint8Array(this.bytes.length + unit8Array.length);
                mergedArray.set(this.bytes);
                mergedArray.set(unit8Array, this.bytes.length);
                this.bytes = mergedArray;
                this.chunksSum = this.chunksSum + 1;
                if(chunksInfo.chunkCount == this.chunksSum) {
                    itiHttpService.post(API.fileManager + '/PostFile' + '?userId=1' 
                    + '&name=' + fileData.name + '&parentId=' 
                    + parentId + '&length=' 
                    + fileData.size + '&collaborativeAreaId=' 
                    + this.ambitId
                    + '&chunkIndex=' + chunksInfo.chunkIndex,
                    JSON.stringify(this.convertToBytes(this.bytes))).catch();
                    this.bytes = new Uint8Array();
                    this.chunksSum = 0;
                    this.refresh(dir);
                }
            });           
                  
        },
    })

    public created() {
        locale(this.language);
        loadMessages(va);
        loadMessages(es);
    }

    fileManager!: any;
    public mounted() {
        if(this.collaborativeAreaId != undefined)
            collaborativeAreaModule.getCollaborativeAreaById(Number.parseInt(this.collaborativeAreaId.toString()));
        if(fileModule.filePath.ambitId != this.collaborativeAreaId){
            fileModule.setPath(['','']);
        }
        this.fileManager = (this.$refs['fileManager'] as DxFileManager).instance;
    }
    
    public get language() {
        return this.$root.$i18n.locale.toString();
    }

    public convertToBytes(unit8Array: Uint8Array) {
        var binary: string = '';
        for(let i = 0; i < unit8Array.byteLength; i++)
            binary += String.fromCharCode(unit8Array[i]);
        return btoa(binary);
    }

    public get height() {
        return window.innerHeight - 220;
    }

    public get width() {
        return window.innerWidth;
    }

    public refresh(dir: FileSystemItem) {
        this.remoteProvider.getItems(dir);
        this.fileManager.repaint();
    }

    public backToHome() {
        this.$router.back();
    }

    public goToAreaHome() {
        this.$router.push({ name: 'CollaborativeAreaDetails', params: { id: this.collaborativeArea.id.toString() } });
    }

    public get collaborativeArea() {
        return collaborativeAreaModule.selectedCollaborativeArea;
    }
}

